import Vue from 'vue';
import _ from 'lodash';
import {
    GET_RECNET_COMPANY_REQUEST,
    GET_RECNET_COMPANY_SUCCESS,
    GET_RECNET_COMPANY_FAILURE,
} from '../mutationTypes';

const state = {
    loading: false,
    companyList: [],
};
const mutations = {
    [GET_RECNET_COMPANY_REQUEST](state) {
        state.loading = true;
    },
    [GET_RECNET_COMPANY_SUCCESS](state, res) {
        state.loading = false;

        state.companyList = res;
    },
    [GET_RECNET_COMPANY_FAILURE](state) {
        state.loading = false;
    }
};

export const actions = {
    async getCompanyName({ commit }) {
        Vue.$storage.init();
        commit(GET_RECNET_COMPANY_REQUEST);

        Vue.$storage.getLocal('COMPANY_CACHE').then(async (rCarNo) => {
            if (_.isEmpty(rCarNo)) {
                // getCompanyName
                const res = await Vue.$ajax.get('getCompanyName');
                if (!res.errorType) {
                    Vue.$storage.update('COMPANY_CACHE', res);
                    console.log(res);
                    commit(GET_RECNET_COMPANY_SUCCESS, res);
                } else {
                    commit(GET_RECNET_COMPANY_FAILURE);
                }
            } else {
                commit(GET_RECNET_COMPANY_SUCCESS, rCarNo);
            }
        }).catch(async () => {
            const res = await Vue.$ajax.get('getCompanyName');

            if (!res.errorType) {
                Vue.$storage.update('COMPANY_CACHE', res);
                commit(GET_RECNET_COMPANY_SUCCESS, res);
            } else {
                commit(GET_RECNET_COMPANY_FAILURE);
            }
        });
    }
};

export default {
    state,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/companyInput.js